import { render, staticRenderFns } from "./OverviewPage.vue?vue&type=template&id=0144a8b2&"
import script from "./OverviewPage.vue?vue&type=script&lang=js&"
export * from "./OverviewPage.vue?vue&type=script&lang=js&"
import style0 from "./OverviewPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports